/* IMPORT */
import { OWNER } from '../objects/superroot.js';
import memo from './memo.js';
import $ from './observable.js';
import resolve from './resolve.js';
/* MAIN */
const tryCatch = (value, fn) => {
    const observable = $();
    return memo((stack) => {
        const error = observable();
        if (error) {
            const reset = () => observable(undefined);
            const options = { error, reset };
            return resolve(fn(options));
        }
        else {
            OWNER.errorHandler = observable;
            return resolve(value);
        }
    });
};
/* EXPORT */
export default tryCatch;
